import { PrintType } from '@/types';
import { StoreState } from '@/redux/types';
import { selectConfigurations } from './selectConfigurations';

export function getPrintTypesForDraft(state: StoreState) {
  return [...new Set<PrintType>(selectConfigurations(state).map(({ printType }) => printType))];
}
